export default __webpack_public_path__ + "static/30-100-91c7cc15776644858d5c400dc95fccfa.jpg";